module.exports = __webpack_public_path__ + "assets/img/março-on-fire-restaurantes-story.bfb26a1c.png";